import { SagaIterator } from "redux-saga";
import { call, put, select } from "typed-redux-saga";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { DataProvider } from "@com.mgmtp.a12.client/client-core/lib/core/data";
import { DocumentServiceFactory } from "@com.mgmtp.a12.kernel/kernel-md-facade";
import { Model } from "@com.mgmtp.a12.client/client-core/lib/core/model";
import { StoreSagas } from "@com.mgmtp.a12.client/client-core/lib/core/store";

import { getChangelog } from "../../utilities/rpcHelper";
import { modelLoadedInScene } from "../../providers/dataProviderHelper";

import { CHANGELOG_DOCUMENT_MODEL } from "./constants";

import isDocumentModel = Model.isDocumentModel;

const documentService = new DocumentServiceFactory().getDocumentService();

export const ChangelogDataProvider: DataProvider = {
	name: "ChangelogDataProvider",
	canHandle({ dataHolder, operation }) {
		return (
			operation === "load" &&
			dataHolder.descriptor.model === CHANGELOG_DOCUMENT_MODEL &&
			dataHolder.descriptor.mainDocumentReference !== undefined
		);
	},
	*provideData({ activityId, operation }): SagaIterator {
		if (operation !== "load") {
			return;
		}

		const activity = yield* select(ActivitySelectors.activityById(activityId));
		if (activity?.descriptor.mainDocumentReference) {
			const docSpec = yield* call(getChangelog, activity.descriptor.mainDocumentReference);

			if (!docSpec) {
				return;
			}

			const criteria = { activityId, modelType: "document" };
			const model = yield* call(StoreSagas.waitForStateChange, modelLoadedInScene(criteria));

			if (!model || !isDocumentModel(model)) {
				return;
			}

			yield* put(
				ActivityActions.setData({
					data: {
						document: documentService.parseDates(docSpec.document, model)
					},
					activityId
				})
			);
		}
	}
};
